import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import TTLProxy from "../../../../common/TTLAsyncProxy";
import {FeedbackEndpoints} from "../../../../common/ProxyEndpoints";
import {Button, ButtonToolbar, UncontrolledTooltip} from "reactstrap";
import Utils from '../../../../common/Utils';
import MDProgress from 'react-md-progress-bar';
import MDSpinner from 'react-md-spinner';
import Icon from 'react-icons-kit';
import {ic_feedback} from 'react-icons-kit/md/ic_feedback';
import {ic_arrow_downward} from 'react-icons-kit/md/ic_arrow_downward';
import ProfileAvatar from "../../../../components/ProfileAvatar/ProfileAvatar";
import './Feedback.css';
import TimeAgo from "../../../../common/TimeAgo";
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

const Styles = {
    feedbackItemStyle:{
        marginBottom: 5
    }
};

const PaginationSteps = [
    {
        offset: 0,
        limit: 5,
    },
    {
        offset: 5,
        limit: 5
    },
    {
        offset: 10,
        limit: 10
    },
    {
        offset: 20,
        limit: 30
    },
    {
        offset: 50,
        limit: 100,
    }
];


const FeedbackItemView  = (props) => {

    const feedback = props.feedback;
    const fullName = Utils.getUserName(feedback.sender);

    return (<div style={Styles.feedbackItemStyle} className="row feedback-item">

        <div className="col-md-1">
            <ProfileAvatar size={32} media={Utils.getUserEntityMedia(feedback.sender)} showFullscreen={false} name={Utils.formatAvatarName(fullName)}/>
        </div>

        <div className="col-md-11">
            <div className="clearfix">
                <h6 className="pull-left">{feedback.title}</h6>

                <div className="pull-right">
                    <UncontrolledTooltip target={`feedback_name_${feedback.id}`} fade={false} placement={"bottom"}>{fullName}</UncontrolledTooltip>
                    <span id={`feedback_name_${feedback.id}`} style={{
                        display: "inline",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 14 }}>{Utils.getFirstName(fullName)}</span>, <TimeAgo style={{display: "inline"}} date={feedback.date_created} tooltipPlacement="bottom" id={`feedback_time_${feedback.id}`}/>
                </div>
            </div>

            <hr/>

            <div><Markdown source={feedback.message}/></div>
        </div>

    </div>);

};

FeedbackItemView.propTypes = {
    feedback: PropTypes.object
};

class Feedback extends Component {

    constructor(props){
        super(props);

        this.state = {
            isBusy: false,
            isLoaded: false,
            feedback: null,
            error: null,
            user: null,
            totalFeedback: 0,
            paginationStep: 0,
        };

        this.proxy = TTLProxy.getInstance();
    }

    nextStep(){

        const step = this.state.paginationStep + 1;

        this.setState({
            paginationStep: step
        },() => {
            this.loadState(step , true );
        });
    }

    loadState(currentStep, append , accumulatedLimit){

        this.setState({
            isBusy: true
        });

        const proxy = this.proxy;
        const options = FeedbackEndpoints.getFeedBacks();
        const step = currentStep === undefined ? this.state.paginationStep : currentStep;

        if(accumulatedLimit){
            options.pagination = { offset: 0 , limit:  this.state.feedback ? this.state.feedback.length : 10 };
        }
        else{
            options.pagination = step >= PaginationSteps.length ? {} : PaginationSteps[step];
        }

        options.include = [ "sender" , "media" ];
        options.sort =  ['-date_created'];

        return proxy.processRequest(options).then(response => {

            if(response.ok) {

                let feedback = this.state.feedback;
                if(append){
                    feedback = (feedback || []).concat(response.getPayload());
                }
                else{
                    feedback = response.getPayload();
                }

                this.setState({
                    feedback: feedback,
                    totalFeedback: response.getPayloadCount(),
                    isLoaded: true,
                    isBusy: false,
                    error: null
                });

            }

        }).catch(err => {

            this.setState({
                isBusy: false,
                error: err
            });

        });

    }

    componentWillMount(){

        //  Load feedback state
        return this.loadState();

    }

    render(){

        const state = this.state;
        const isBusy = state.isBusy;
        const isLoaded = state.isLoaded;
        const feedback = state.feedback;
        const totalFeedback = state.totalFeedback;
        const canShowMore = feedback ? feedback.length < totalFeedback : false;

        return <DocumentTitle title="User Feedback">

            <div style={{padding: 25}}>

                <div style={{marginBottom: 4}}>
                    <div className="clearfix">
                        <div className="pull-left">
                            <h5><Icon icon={ic_feedback} size={24}/> Feedback</h5>
                        </div>
                        <div className="pull-right">
                            <ButtonToolbar>
                                <Button color={"secondary"} style={{borderRadius: 4}} onClick={() => this.loadState(undefined ,undefined , true ) }><i className="fa fa-refresh"></i> Refresh</Button>
                            </ButtonToolbar>
                        </div>
                    </div>
                </div>

                {isBusy && isLoaded && <MDProgress show={true} />}

                <hr/>

                {/*Real Content Here*/}
                {isLoaded ?  feedback.length === 0 ? <div className="text-center">
                    <img href="/img/cloud_logo.png"/>
                    <p>Oops! Seems there are no feedback sent yet!</p>
                </div> :
                    <div>

                        {feedback.map((item,index) => {
                            return <FeedbackItemView key={index} feedback={item}/>
                        })}

                        {canShowMore && (state.paginationStep < PaginationSteps.length) && <div className="text-center">

                            <Button color={"secondary"} style={{ borderRadius: 4 }} onClick={() => {
                                this.nextStep();
                            }}>Show more <Icon icon={ic_arrow_downward}/></Button>

                        </div>}

                </div>:
                    <div className="text-center" style={{padding: 20}}>

                        <MDSpinner size={60}/>
                        <p>Please hold on, fetching user feedback...</p>

                </div>}



            </div>

        </DocumentTitle>;

    }

}

export default  Feedback;



// WEBPACK FOOTER //
// ./src/views/Extras/UserSupport/Feedback/Feedback.js